/**
 * Real testimonials — verbatim from the live site's #recenzije section
 * (index.html `review-1`/`review-2` keys) for BS, and the real EN
 * dictionary entries for EN (these two were already accurate/consistent
 * between languages, unlike the portfolio case-study copy — see
 * lib/portfolio.ts header).
 */

export interface Testimonial {
  id: string
  quote: string
  quoteEn: string
  name: string
  role: string
  roleEn: string
}

export const TESTIMONIALS: Testimonial[] = [
  {
    id: 'nermin',
    quote:
      'Ermin je kompletno preuzeo naš digitalni identitet — logo, vizit karta, reklame uz put, web stranica s galerijom i admin panelom. Sve je odrađeno brzo, profesionalno i tačno onako kako smo zamislili. Sada sami ažuriramo cijene i fotografije, bez da zovemo ikoga. Svaka preporuka.',
    quoteEn:
      'Ermin took over our entire digital identity — logo, business cards, roadside billboards, website with gallery and admin panel. Everything was done quickly, professionally and exactly as we envisioned. We now update prices and photos ourselves, without calling anyone. Highly recommended.',
    name: 'Nermin',
    role: 'Direktor, Tehnostan d.o.o.',
    roleEn: 'Director, Tehnostan d.o.o.',
  },
  {
    id: 'admir',
    quote:
      'Nisam očekivao da će mi web stranica toliko brzo biti gotova — a kad sam je vidio, odmah sam znao da je to to. Ermin je bez puno priče razumio šta firma treba i napravio je tačno to. Nema zalihažanja, nema skrivenih troškova. Sad kad neko pita za naš posao, uputim ih na stranicu i više ne moram ništa objasnjavati.',
    quoteEn:
      'I didn\u2019t expect the website to be ready so fast — and when I saw it, I knew immediately that was it. Ermin understood what the business needed without much explanation and delivered exactly that. No fuss, no hidden costs. Now when someone asks about our work, I just point them to the site and don\u2019t need to explain anything anymore.',
    name: 'Admir',
    role: 'Vlasnik, MM Metal',
    roleEn: 'Owner, MM Metal',
  },
]
